import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AncillaryServicesPageComponent } from './ancillary-services-page.component';
import { AncillaryServicesDomainModule } from "app_locobook/domain/ancillaryServices/ancillary-services-domain.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import {
    CacheQuotedAvailabilityModule
} from "app_locobook/service/cache-quoted-availability/cache-quoted-availability.module";
import { IframeAppEmbedderModule } from "libraries/component/iframe-app-embedder/iframe-app-embedder.module";
import {
    AncillaryServicesPageService
} from "./ancillary-services-page.service";
import { AirBookingResourceModule } from "libraries/service/resources/air-booking/air-booking-resource.module";
import { AirQuoteResourceModule } from "libraries/service/resources/airQuote/airQuoteResource.module";

@NgModule({
    declarations: [
        AncillaryServicesPageComponent,
    ],
    exports: [
        AncillaryServicesPageComponent,
    ],
    providers : [
        AncillaryServicesPageService,
    ],
    imports: [
        CacheQuotedAvailabilityModule,
        CommonModule,
        AncillaryServicesDomainModule,
        LoaderModule,
        NotificationModule,
        IframeAppEmbedderModule,
        AirBookingResourceModule,
        AirQuoteResourceModule,
    ]
})
export class AncillaryServicesPageModule {
}
